import { useState } from 'react';

export const ORGANIZATION_LOGO_URL = '/api/org/media-branding/logo';

export default function OrganizationLogoAvatar({ sizeClass = 'w-12 h-12', textClass = 'text-lg' }) {
  const [failed, setFailed] = useState(false);
  if (failed) {
    return (
      <div
        className={`${sizeClass} rounded-full flex-shrink-0 flex items-center justify-center font-bold text-white ${textClass}`}
        style={{ background: '#0A66C2' }}
        data-testid="preview-org-logo-fallback"
      >
        MT
      </div>
    );
  }
  return (
    <img
      src={ORGANIZATION_LOGO_URL}
      alt="Mayr Technologies logo"
      data-testid="preview-org-logo"
      className={`${sizeClass} rounded-full flex-shrink-0 object-contain`}
      style={{ background: '#0A66C2' }}
      onError={() => setFailed(true)}
    />
  );
}
